export default class CategoriesView {
    constructor(element) {
        this.browsePane = element.querySelector('[data-browse-pane]');
        this.resultsPane = element.querySelector('[data-search-results-pane]');
        this.enableBrowseModeButton = element.querySelector('[data-browse-all-button]');
        this.searchField = element.querySelector('[data-search-field]');

        this.showBrowse();
        this.searchField.addEventListener('keyup', this.updateVisiblePane.bind(this));

        this.enableBrowseModeButton.addEventListener('click', this.enableBrowseMode.bind(this));
    }

    updateVisiblePane(event) {
        const isUserSearching = event.currentTarget.value.length > 0;

        this.hideElement(this.resultsPane);
        this.hideElement(this.browsePane);

        if (isUserSearching) {
            this.showElement(this.resultsPane);
            this.showElement(this.enableBrowseModeButton);
        } else {
            this.showBrowse();
        }
    }

    hideElement(element) {
        element.setAttribute('data-hidden', true);
    }

    showBrowse() {
        this.showElement(this.browsePane);
        this.hideElement(this.enableBrowseModeButton);
    }

    showElement(element) {
        element.removeAttribute('data-hidden');
    }

    enableBrowseMode() {
        this.showBrowse();
        this.hideElement(this.resultsPane);
        this.searchField.value = '';
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/CategoriesView.js